import styled from "styled-components";

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
`

export const Content = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const MobileContent = styled.div`
  width: 100%;
  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    display: block;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  @media only screen and (${({theme}) => theme.media.small}) {
    flex-direction: row;
  }
`

export const BlockText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`

export const BlockPhone = styled.div`
  display: flex;
  padding: 10px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`

export const PhoneImage = styled.img`
  width: 100%;
  height: auto;

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    float: right;
  }

  @media only screen and (min-width: 1800px) {
    width: 80%;
  }
`

export const PhoneImage2 = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;

  @media only screen and (${({theme}) => theme.media.medium}) {
    width: 50%;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    display: none;
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    float: right;
  }

  @media only screen and (min-width: 1800px) {
    width: 80%;
  }
`